import React from 'react';
import {
  Row,
  Col,
  FormGroup,
  Badge,
  Label,
  Input,
  Button,
  Card,
  CardBody,
  CardTitle,
  CardText,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap';
import SelectAsyncComponent from '../../../../../../componentes/select/select-async.component';
import './multiplos-exames.styles.css';
import * as acessos from '../../../../../../acessos.const.util';
import SelectComponent from '@componentes/select/select.component';
import IntlMessage from '../../../../../../helpers/intlMessage';
import { useIntl } from 'react-intl';

const MultiposExamesPage = (props) => {
  const intl = useIntl();

	function translate(key) {
	  return intl.formatMessage({ id: key });
	}
  return (
    <div className='mv-multiplos-exames-container'>
      <Modal isOpen={props.modal} toggle={props.toggle}>
        <ModalHeader toggle={props.toggle}><IntlMessage id = "dashboards.examDetail.addExam"/></ModalHeader>
        <ModalBody>
          <Row>
            <Col>
              <FormGroup>
                <Label><IntlMessage id = "dashboards.examDetail.exams"/></Label>
                <SelectComponent
                  options={props.listagemExames}
                  value={props.exameSelecionado}
                  placeholder={translate("dashboards.examDetail.selectExam")}
                  onChange={(event) =>
                    props.atualizaInputNoState('exameSelecionado', event)
                  }
                  disabled={props.modalAbertoEmEdicao}
                />
              </FormGroup>
            </Col>
            <Col sm={3}>
              <FormGroup>
                <Label><IntlMessage id = "dashboards.examDetails.quantity"/></Label>
                <Input
                  type='number'
                  min={1}
                  value={props.quantidade}
                  onChange={(event) =>
                    props.atualizaInputNoState(
                      'quantidade',
                      event.currentTarget.value
                    )
                  }
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col>
              <FormGroup>
                <Label><IntlMessage id = "dashboards.examDetail.performingPhysician"/></Label>
                <SelectAsyncComponent
                  options={props.listagemMedicoSolicitante}
                  placeholder={translate("dashboards.examDetail.selectDoctor")}
                  value={props.medicoSelecionado}
                  disabled={
                    props.faturarMedicoPadrao && props.medicoExecutantePadrao
                  }
                  onChange={(event) =>
                    props.atualizaInputNoState('medicoSelecionado', event)
                  }
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col>
              <FormGroup>
                <Label><IntlMessage id = "dashboards.examDetail.annotationsExam"/></Label>
                <Input
                  type='textarea'
                  value={props.anotacao}
                  onChange={(event) =>
                    props.atualizaInputNoState(
                      'anotacao',
                      event.currentTarget.value
                    )
                  }
                />
              </FormGroup>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button
            onClick={props.adicionarOuAtualizarExame}
            color='primary'
            disabled={props.disabledGravar()}
          >
            <IntlMessage id = "dashboards.examDetails.confirm"/>
          </Button>
          <Button onClick={props.toggle} color='secondary'>
            <IntlMessage id = "dashboards.examDetails.cancel"/>
          </Button>
        </ModalFooter>
      </Modal>

      <p className='title'><IntlMessage id = "dashboards.examDetail.multiploExams"/></p>
      {props.acessoPermitido(props.usuario, acessos.MultiplosExames) &&
        props.acessoPermitido(props.usuario, acessos.Adicionar) && (
          <Row className='marginTop-ActionButton'>
            <Col sm='auto' className='paddingRight-zero'>
              <FormGroup>
                <Button
                  style={{ marginTop: '33px' }}
                  color='link'
                  onClick={props.toggle}
                  disabled={props.exameLiberado}
                >
                  <span><IntlMessage id = "dashboards.examDetail.addExam"/></span>
                </Button>
              </FormGroup>
            </Col>
          </Row>
        )}
      <br />
      <div
        style={{
          height: `${props.altura - 104}px`,
          overflowY: 'scroll',
          overflowX: 'hidden',
        }}
      >
        {props.listagemMultiplosExames !== undefined &&
          props.listagemMultiplosExames.map((exames) => {
            return (
              <Row key={exames.exame}>
                <Col>
                  <Card>
                    <CardBody>
                      <Row>
                        <Col>
                          <CardTitle>{exames.exameNome}</CardTitle>
                          <CardText><IntlMessage id = "dashboards.examDetails.quantity"/> {exames.quantidade}</CardText>
                        </Col>
                        <Col>
                          <div>
                            {!props.exameLiberado && (
                              <div>
                                {!exames.faturado &&
                                  props.acessoPermitido(
                                    props.usuario,
                                    acessos.MultiplosExames
                                  ) &&
                                  props.acessoPermitido(
                                    props.usuario,
                                    acessos.Editar
                                  ) && (
                                    <Button
                                      color='info'
                                      onClick={() =>
                                        props.editarExame(exames.exame)
                                      }
                                    >
                                      <span><IntlMessage id = "dashboards.examDetail.edit"/></span>
                                    </Button>
                                  )}
                                {!exames.faturado &&
                                  props.acessoPermitido(
                                    props.usuario,
                                    acessos.MultiplosExames
                                  ) &&
                                  props.acessoPermitido(
                                    props.usuario,
                                    acessos.Apagar
                                  ) && (
                                    <Button
                                      color='danger'
                                      onClick={() =>
                                        props.apagarExame(exames.exame)
                                      }
                                    >
                                      <span><IntlMessage id = "dashboards.examDetail.delete"/></span>
                                    </Button>
                                  )}
                                {!exames.faturado &&
                                  props.acessoPermitido(
                                    props.usuario,
                                    acessos.MultiplosExames
                                  ) &&
                                  props.acessoPermitido(
                                    props.usuario,
                                    acessos.Faturar
                                  ) && (
                                    <Button
                                      color='primary'
                                      onClick={() =>
                                        props.faturarExameComplementar(
                                          exames.exame
                                        )
                                      }
                                    >
                                      <span><IntlMessage id = "dashboards.examDetail.billExam"/></span>
                                    </Button>
                                  )}
                                {exames.faturado &&
                                  props.acessoPermitido(
                                    props.usuario,
                                    acessos.MultiplosExames
                                  ) &&
                                  props.acessoPermitido(
                                    props.usuario,
                                    acessos.Apagar
                                  ) && (
                                    <Button
                                      color='danger'
                                      onClick={() =>
                                        props.cancelamentoFaturamento(
                                          exames.exame
                                        )
                                      }
                                    >
                                      <span><IntlMessage id = "dashboards.examDetail.cancelBilling"/></span>
                                    </Button>
                                  )}
                              </div>
                            )}
                          </div>
                        </Col>
                      </Row>
                      {exames.faturado && (
                        <CardText className='status-container'>
                          <Badge color='success'><IntlMessage id = "dashboards.examDetail.billed"/></Badge>
                        </CardText>
                      )}
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            );
          })}
      </div>
    </div>
  );
};

export default MultiposExamesPage;



// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/material/tabs/multiplosExames/multiplos-exames.page.js